//
//
//
//
//
//

import { parentMixin } from '../../mixins/multi-items'

export default {
  name: 'button-tab',
  mixins: [parentMixin],
  props: {
    height: Number
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/button-tab/button-tab.vue